import { useEffect, useState } from 'react';
import { loadGuests, refreshGuestsFromApi } from '../services/GuestService';
import { GUESTS_ENABLED } from '../constants/featureFlags';
import { honoreeNames } from '../utils/coupleNames';

export type CoupleNamesStatus = 'loading' | 'ready' | 'failed' | 'off';

/**
 * The honoree names (the couple), kept in step with the guest list. `status`
 * says whether the answer is known: a screen must not treat an empty list as
 * "no honorees" while loading, after a failed load (for example a role that
 * cannot list guests), or when the guests module is off.
 */
export function useCoupleNames(): { names: string[]; status: CoupleNamesStatus } {
  const [names, setNames] = useState<string[]>(() => honoreeNames(loadGuests()));
  const [status, setStatus] = useState<CoupleNamesStatus>(GUESTS_ENABLED ? 'loading' : 'off');
  useEffect(() => {
    if (!GUESTS_ENABLED) return;
    let live = true;
    refreshGuestsFromApi()
      .then(() => { if (live) { setNames(honoreeNames(loadGuests())); setStatus('ready'); } })
      .catch(() => { if (live) setStatus('failed'); });
    return () => { live = false; };
  }, []);
  return { names, status };
}
